module.exports = __webpack_public_path__ + "img/icon_dimenu.b5a79fb7.svg";